import { TextField, TextFieldProps } from "@mui/material";
import React from "react";

export function TextInput(props: TextFieldProps & { inputTestId?: string }) {
  const { InputProps, inputTestId, ...rest } = props;
  const className = "h-10 rounded py-2 px-0 leading-tight ";
  const propsClassName = InputProps?.className ?? "";

  // Create a new InputProps object that includes the existing InputProps and the new className
  const newInputProps = {
    ...InputProps,
    className: className + propsClassName,
    inputProps: {
      ...(InputProps?.inputProps || {}),
      ...(inputTestId ? { "data-testid": inputTestId } : {}), // Add data-testid to the underlying input element
    },
  };

  return <TextField {...rest} InputProps={newInputProps} />;
}
